import type {
  QuestionDateModelData,
  SurveyAnswerRecord,
  SurveyAnswerValue,
  SurveyElementJson,
} from '@coorum-research/shared-common/types'
import type { SurveyModel } from 'survey-core'
import type { SurveyElementFormHandler } from './survey-element-form'
import { ValidationErrorMessages } from '@coorum-research/shared-common/shared/survey/survey-validation'

export class SurveyElementFormHandlerDate implements SurveyElementFormHandler {
  readonly #elementJson: SurveyElementJson
  #elementResultRecord: SurveyAnswerRecord | null

  constructor(
    elementJson: SurveyElementJson,
    elementResultRecord: SurveyAnswerRecord | null,
  ) {
    this.#elementJson = elementJson
    this.#elementResultRecord = elementResultRecord
  }

  get elementJson(): SurveyElementJson {
    return this.#elementJson
  }

  get surveyModel(): SurveyModel | null {
    return null
  }

  get data(): SurveyAnswerRecord {
    return this.#elementResultRecord || {}
  }

  getValue(): SurveyAnswerValue {
    return this.#elementResultRecord?.[this.#elementJson.name] ?? ''
  }

  getComment(): string {
    return this.#elementResultRecord?.[`${this.#elementJson.name}-Comment`] as string || ''
  }

  setElementResultRecordValue(value: SurveyAnswerValue) {
    if (!this.#elementResultRecord) {
      this.#elementResultRecord = {}
    }
    this.#elementResultRecord[this.#elementJson.name] = value
  }

  setElementResultRecordComment(comment: string) {
    if (!this.#elementResultRecord) {
      this.#elementResultRecord = {}
    }
    this.#elementResultRecord[`${this.#elementJson.name}-Comment`] = comment
  }

  validate(): {
    isValid: boolean
    errorMessage?: string
  } {
    const value = this.getValue()

    // 必須チェック
    if (this.#elementJson.isRequired && (value === null || value === undefined || value === '')) {
      return {
        isValid: false,
        errorMessage: ValidationErrorMessages.REQUIRED,
      }
    }

    if (typeof value === 'string' && value !== '') {
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) {
        return {
          isValid: false,
          errorMessage: ValidationErrorMessages.INVALID_DATE,
        }
      }

      const element = this.#elementJson as QuestionDateModelData

      // 日付の最小値チェック
      const min = element.min
      if ((min != null) && date < new Date(min)) {
        return {
          isValid: false,
          errorMessage: ValidationErrorMessages.MIN_DATE(min),
        }
      }

      // 日付の最大値チェック
      const max = element.max
      if ((max != null) && date > new Date(max)) {
        return {
          isValid: false,
          errorMessage: ValidationErrorMessages.MAX_DATE(max),
        }
      }
    }
    return {
      isValid: true,
    }
  }
}
